const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInlaopatuxay',
    accessToken: 'accessTokenlaopatuxay',
    userRole: 'userRole',
  }
}

export default AppConfig;
